/**
 * @generated SignedSource<<d62f5dcabfa05937124252c13e0b7a47>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutGuestBuyerQueryRenderer_emailUser$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useBuyerFetchHandler_emailUser">;
  readonly " $fragmentType": "CheckoutGuestBuyerQueryRenderer_emailUser";
};
export type CheckoutGuestBuyerQueryRenderer_emailUser$key = {
  readonly " $data"?: CheckoutGuestBuyerQueryRenderer_emailUser$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutGuestBuyerQueryRenderer_emailUser">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutGuestBuyerQueryRenderer_emailUser",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useBuyerFetchHandler_emailUser"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "9988d8fce93f014a74664d8071d0440c";

export default node;
